import { Component, OnInit, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../../api.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-digital-facility-add',
  templateUrl: './college-facility-add.component.html',
  styleUrls: ['./college-facility-add.component.scss']
})
export class CollegeFacilityComponent implements OnInit {

  public colleges = [];
  public collegefacilities = [];
  public facilities = [];
  collegefacilitiesForm: FormGroup;
  public message:any = null;
  public class:any = null;
  submitted = false;

  constructor(private router: Router, private api: ApiService, private formBuilder: FormBuilder, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public settings = {
    actions: {
      position: 'right',
      add: false
    },
    edit: {
      confirmSave: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      facilities: {
        title: 'Facilities'
      },
      collegeid: {
        title: 'Collegeid',
        editable:false,
      },
    },
  };

  public config1: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null
  };

  public onUploadInit(args: any): void { }

  public onUploadError(args: any): void { }

  public onUploadSuccess(args: any): void { }

  ngOnInit() {
    this.collegefacilitiesForm = this.formBuilder.group({
      facilities: ['', Validators.required],
      collegeid: ['', Validators.required],
    });

    this.http.get<any>(this.api_endpoint+'/colleges').subscribe(
        data => {
          this.colleges = data.data;
          // console.log(this.specializations);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    this.http.get<any>(this.api_endpoint+'/collegefacilities').subscribe(
        data => {
          this.collegefacilities = data.data;
          // console.log(this.specializations);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    this.http.get<any>(this.api_endpoint+'/facilities').subscribe(
        data => {
          this.facilities = data.data;
          // console.log(this.specializations);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.collegefacilitiesForm.controls; }

  onFormSubmit() {
    this.submitted = true;

    if (this.collegefacilitiesForm.invalid) {
      return;
    }
    // console.log(this.collegefacilitiesForm.value);
    this.http.post<any>(this.api_endpoint+'/collegefacilities', this.collegefacilitiesForm.value).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        }
        window.location.reload();
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  updateRecord(event) {
    // console.log(event.newData);
    var data = {
                "facilities" : event.newData.facilities,
                "collegeid" : event.newData.collegeid,
                "_id" : event.newData._id,
                };
        console.log(data);     
        this.http.put<any>(this.api_endpoint+'/collegefacilities/', data).subscribe(
        res => {
          // console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          }
          event.confirm.resolve(event.newData);
          this.ngOnInit();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }

}
